import { render, staticRenderFns } from "./homeswipe.vue?vue&type=template&id=fd61f2f4&scoped=true"
import script from "./homeswipe.vue?vue&type=script&lang=js"
export * from "./homeswipe.vue?vue&type=script&lang=js"
import style0 from "./homeswipe.vue?vue&type=style&index=0&id=fd61f2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd61f2f4",
  null
  
)

export default component.exports